import { MetaReducer } from '@ngrx/store';
import { routerReducer } from '@ngrx/router-store';
import { AppState } from '../app.state';
import * as fromAuthReducer from './auth.reducer';
import * as fromAccountReducer from './account.reducer';
import * as fromSharedReducer from './shared.reducer';
import * as fromAuth from './auth.reducer';
import * as fromTournament from './tournament.reducer';
import { environment } from 'src/environments/environment';

export const reducers = {
  auth: fromAuth.reducer,
  router: routerReducer,
  account: fromAccountReducer.reducer,
  shared: fromSharedReducer.reducer,
  tournament: fromTournament.reducer
};

export const metaReducers: MetaReducer<AppState>[] = !environment.production
  ? []
  : [];
